export default "__VITE_ASSET__3a03f0ef__"